import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';

import { PlayerState } from '../player/state/player.reducer';
import * as fromPlayerActions from '../player/state/player.actions';

@Component({
  selector: 'channel-watch',
  templateUrl: './watch.component.html',
  styleUrls: ['./watch.component.scss']
})
export class ChannelWatchComponent implements OnInit, OnDestroy {

  channelId = 0;

  public getUrlChannel!: string;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private playerStore: Store<PlayerState>,
  ) {
    this.route.params.subscribe(c => { this.channelId = c.id; });

  }

  ngOnInit(): void {
    // TODO: this componnent must read the appp state and get the complete Channel object. i.e: channel.URL
    // this.playerStore.dispatch(fromPlayerActions.PlayRequest({url: 'https://mysat-live-test.ercdn.net/dmchd/dmchd.m3u8'}));
  }

  ngOnDestroy(): void {
    this.playerStore.dispatch(fromPlayerActions.StopRequest());
  }

  public setUrlChannel(event: string): void{
    if (event !== '')
    {
      this.playerStore.dispatch(fromPlayerActions.StopRequest());
      this.getUrlChannel = event;
      this.playChannel(this.getUrlChannel);
    }
  }

  private playChannel(urlChannel: string): void{
    this.playerStore.dispatch(fromPlayerActions.PlayRequest({url: urlChannel, PiP: false}));
  }
}
